var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.945,
    cy: 1,
    r: 1.186,
    gradientTransform: "matrix(-0.692, -0.722, 0.826, -0.793, 0.772, 2.474)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fccb7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#f87045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a521e0"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M22.5,0h0a22.5,22.5,0,0,0,0,45H41.269A3.731,3.731,0,0,0,45,41.268V22.5A22.5,22.5,0,0,0,22.5,0M36.875,22.5a14.375,14.375,0,1,1-28.75,0V10.509a2.384,2.384,0,0,1,2.384-2.384H22.5A14.375,14.375,0,0,1,36.875,22.5Z",
    fill: "url(#radial-gradient)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotShape);
export default __webpack_public_path__ + "static/media/bot-shape.75aad5a205328ed4fe4653ad29a94be4.svg";
export { ForwardRef as ReactComponent };